/**
 * Lightweight accessibility remediations for audit failures that can't be
 * fixed solely in Liquid (missing theme blocks, video_tag posters, etc.).
 */
(() => {
  const shopName =
    document.querySelector('h1.visually-hidden')?.textContent?.trim() ||
    document.title.split('|')[0]?.trim() ||
    'Home';

  // Fix broken logo translation-missing alt text
  document.querySelectorAll('.header-logo__image, .header-logo img').forEach((img) => {
    if (!(img instanceof HTMLImageElement)) return;
    if (!img.alt || img.alt.includes('Translation missing')) {
      img.alt = `${shopName} home`;
    }
  });

  // Decorative / missing alt on media (video posters, etc.)
  document.querySelectorAll('img:not([alt])').forEach((img) => {
    if (!(img instanceof HTMLImageElement)) return;
    const isVideoPoster =
      img.src.includes('preview_images') ||
      img.closest('video, deferred-media, .hero__media-grid, .video-background') != null;
    img.alt = isVideoPoster ? '' : shopName;
  });

  // Distinct landmark names for footer menus
  document.querySelectorAll('footer nav.details-content:not([aria-label])').forEach((nav, index) => {
    const details = nav.closest('details');
    const heading =
      details?.querySelector('.menu__heading__default')?.textContent?.trim() ||
      details?.querySelector('summary')?.textContent?.trim();
    nav.setAttribute('aria-label', heading || `Footer menu ${index + 1}`);
  });

  // Fix product titles that still use invalid <p role="heading">
  document.querySelectorAll('p[role="heading"]').forEach((p) => {
    const level = p.getAttribute('aria-level') || '3';
    const heading = document.createElement(`h${level}`);
    heading.innerHTML = p.innerHTML;
    heading.className = p.className;
    p.replaceWith(heading);
  });

  // Fix blog heading skip (h2 -> h4) by promoting h4 under Inside Stegmann
  document.querySelectorAll('.featured-blog-posts-card h4, [data-testid="featured-blog-posts"] h4').forEach((h4) => {
    const h3 = document.createElement('h3');
    h3.innerHTML = h4.innerHTML;
    h3.className = h4.className;
    h4.replaceWith(h3);
  });

  // Make sure aria-hidden slides are not focusable before JS slideshow runs
  document.querySelectorAll('slideshow-slide[aria-hidden="true"]:not([inert])').forEach((slide) => {
    slide.setAttribute('inert', '');
  });

  // Improve empty overlay links that only have placeholder aria-labels
  document.querySelectorAll('a.group-block__link[aria-label^="hero-apparel"]').forEach((link) => {
    if (!(link instanceof HTMLAnchorElement)) return;
    const heading = link.parentElement?.querySelector('h1, h2, h3, h4, p')?.textContent?.trim();
    if (heading) link.setAttribute('aria-label', heading);
  });
})();
